import { NgModule, inject } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

@NgModule({})
export class FaIconsModule {
  readonly library = inject(FaIconLibrary);
  constructor() {
    this.library.addIconPacks(fas, far);
  }
}
